import {
    CatalogDataCustomOptionInterface,
    ConfigurableProductDataConfigurableItemOptionValueInterface,
} from '@wearejh/swagger-rxjs/lib/Definitions';
import { ActionMap, createMsg } from 'action-typed';
import { DataStatus } from '@wearejh/m2-pwa-engine/lib/types';

import { CartState } from './cart.reducer';
import {
    ConfigurableProductCartItemInput,
    SimpleProductCartItemInput,
    CartItemInput,
} from './queries/__generated__/types';

export const STORAGE_KEY_CART = 'store.cart';

export type ConfigOption = ConfigurableProductDataConfigurableItemOptionValueInterface;
export type CustomOption = CatalogDataCustomOptionInterface;

/**
 * Type alias's for consumers
 */
export type CartAddItem = CartItemInput;
export type CartAddParams = {
    items: CartAddItem[];
    price?: number;
};

export type CartAddSimpleItem = SimpleProductCartItemInput;
export type CartAddSimpleParams = {
    items: CartAddSimpleItem[];
};

export type CartAddConfigItem = ConfigurableProductCartItemInput;
export type CartAddConfigParams = {
    items: CartAddConfigItem[];
};

export type CartFetchParams = Pick<CartState, 'cartId' | 'totals' | 'items' | 'items_qty' | 'raw'>;

export type CartItemDeleteParams = {
    itemId: number;
};

export type CartItemUpdateParams = {
    itemId: number;
    qty: number;
};

export type Messages = {
    ['Cart.SetStatus']: DataStatus;
    ['Cart.Refresh']: { force: boolean };

    ['Cart.Fetch']: { cartId?: string } | undefined;
    ['Cart.FetchSuccess']: CartFetchParams;
    ['Cart.FetchError']: string;
    ['Cart.FetchSkipped']: undefined;
    ['Cart.FetchCancel']: undefined;

    ['Cart.CreateEmpty']: undefined;
    ['Cart.CreateEmptySuccess']: CartFetchParams;
    ['Cart.CreateEmptyError']: string;

    ['Cart.Persist']: undefined;
    ['Cart.ProcessPendingProduct']: undefined;
    ['Cart.HydrateFromLocalStorage']: Partial<CartState>;
    ['Cart.Reset']: undefined;

    // item delete
    ['Cart.ItemDelete']: CartItemDeleteParams;
    ['Cart.ItemDeleteSuccess']: undefined;
    ['Cart.ItemDeleteError']: string;

    // item update
    ['Cart.ItemUpdate']: CartItemUpdateParams[];
    ['Cart.ItemUpdateSuccess']: undefined;
    ['Cart.ItemUpdateError']: string;

    ['Cart.ClearItemMessages']: number;
    ['Cart.ClearAllItemMessages']: undefined;

    ['Cart.Add.Config']: CartAddConfigParams;
    ['Cart.Add.Simple']: CartAddSimpleParams;
    ['Cart.Add']: CartAddParams;
    ['Cart.ClearMessages']: undefined;
    ['Cart.AddSuccess']: undefined;
    ['Cart.AddComplete']: undefined;

    ['Cart.AddError']: string;
    ['Cart.ProceedToCheckoutPage']: undefined;
    ['Cart.ValidationFailed']: string;
    ['Cart.Noop']: string | undefined;
};

export const Msg = createMsg<Messages>();
export const CartMsg = Msg;
export type TypeMap = ActionMap<Messages>;
export type Handler = TypeMap[keyof TypeMap];
export type Actions = Handler;
export type CartActions = Actions;
